import { Typography } from "@aviary";
import type { TypographyType } from "@aviary/components/Typography";
import { e2eAttributes } from "@shared/e2eAttributes";

import * as styles from "./ProductName.styles";

interface Props {
  name: string;
  changeOnHover?: boolean;
  isNoClip?: boolean;
  wordWrap?: boolean;
  type?: TypographyType;
  typographySizeOverride?: TypographyType;
}

const ProductName = ({
  name,
  changeOnHover = true,
  isNoClip,
  wordWrap,
  type = "h4",
  typographySizeOverride,
  ...rest
}: Props) => {
  const getProductNameStyles = [
    styles.productName.base,
    changeOnHover && styles.productName.changeOnHover,
    isNoClip && styles.productName.noClip,
    !wordWrap && styles.nowrap,
  ];

  const getSizeOverride = () => {
    if (typographySizeOverride) {
      return typographySizeOverride;
    }

    return type;
  };

  return (
    <Typography
      data-e2e={e2eAttributes.productName(name)}
      sizeOverride={getSizeOverride()}
      css={getProductNameStyles}
      type={type}
      title={name}
      {...rest}
    >
      {name}
    </Typography>
  );
};

export { ProductName };
